import { t } from '../../i18n';

const actions = {
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  DISMISS_NOTIFICATION: 'DISMISS_NOTIFICATION',
  CLEAN_NOTIFICATIONS: 'CLEAN_NOTIFICATIONS',
  REQUEST_ERROR: 'REQUEST_ERROR',

  addNotification: data => {
    const id = new Date().getTime();

    return {
      type: actions.ADD_NOTIFICATION,
      payload: { ...data, id },
    };
  },

  // The standard success toast: the shared "Success" headline over the given message.
  /** @param {string} message */
  success: message =>
    actions.addNotification({
      headline: t('dash.common.notification.success_headline'),
      type: 'success',
      message,
    }),

  requestError: data => {
    const id = new Date().getTime();

    return {
      type: actions.REQUEST_ERROR,
      payload: { ...data, id },
    };
  },

  dismissNotification: data => {
    return {
      type: actions.DISMISS_NOTIFICATION,
      payload: data,
    };
  },
};

export default actions;
